import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { verifySession } from "../helpers/sessions"; // Update the path as needed
import { useAuth } from "../stores/Auth/Auth";
import { canView } from "../helpers/permissions";
import { Spinner } from "reactstrap";

export const AuthProtected = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuth, setIsAuth] = useState(null);
  const [user, setUser] = useState(null);
  const { verifyToken } = useAuth((state) => state); // Assuming verifySession is passed as a prop
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      setIsLoading(true);
      const access = await canView(props?.name);
      const result = await verifyToken();
      setHasAccess(access);
      if (result) {
        setUser(result?.user); // Get full user object
        setIsAuth(true);
      } else {
        setIsAuth(false);
      }
      setIsLoading(false);
    };

    checkAuth();
  }, [verifyToken, props?.name]);

  if (isLoading) {
    // Show a loading spinner centered
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <Spinner size={"sm"} />
      </div>
    );
  }

  if (!isAuth) {
    return <Navigate to="/login" />;
  }

  if (!hasAccess) {
    return <Navigate to="/dashboard" state={{ accessDenied: true }} />;
  }

  // Check if user needs to complete onboarding
  if (user && user.onboardingCompleted === false) {
    const step = user.onboardingStep || 1;
    return <Navigate to={`/onboarding?step=${step}`} />;
  }

  // Assuming you have a way to check for temporary passwords
  // This part needs to be integrated based on your actual logic
  // For now, we're assuming that `user` object might have a `tempPassword` property
  if (user && user.tempPassword) {
    return <Navigate to="/reset-password" />;
  }

  return <React.Fragment>{props.children}</React.Fragment>;
};
